import { type FC } from 'react';
import { Outlet, useLocation } from 'react-router';
import NavBar from './NavBar';

export const NavBarLayout: FC = () => {
    const { pathname } = useLocation();
    return (
        <>
            <NavBar
                showProjectMenus={!pathname.startsWith('/generalSettings')}
            />
            <Outlet />
        </>
    );
};
